import axios from "axios";
import { Category } from "../@types/Category";

const endpoint_user = "categories";

const API_URL_USER = (process.env.REACT_APP_API_URL as string) + endpoint_user;

export class CategoryService {
  // Método para verificar usuarios
  static async getCategories(): Promise<Category[]> {
    try {
      const response = await axios.get(`${API_URL_USER}`, {
        params: {  },
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || "Error al obtener categorias");
    }
  }

 
}
